// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1Ph6v","footer":"ReportModalFilter_footer__1dL85"};